import IframeResizer from "iframe-resizer-react";
import React, { useRef, useEffect, useState } from "react";
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { AccountBillingDetailsService as BillingService } from "gw-capability-billing";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import _ from "lodash";
import appConfig from "app-config";
import { LoaderExt } from "gw-components-platform-react";
// eslint-disable-next-line import/no-cycle
import styles from './PEPaymentComponentExt.module.scss';

// import LoaderExt from ''

function BluePay(props) {
  const [isLoading, setLoadingState] = useState(false);
    const accountNumber = props.accountNumber;
    const { history,setCallback } = props;
    const email = props.userInfo.email;
    const amountDue = props.amountDue;
    const [creditCardInfo, setCreditCardInfo] = useState({});
    const { authHeader } = useAuthentication();
    const ref = useRef(null);
    const [messageData, setMessageData] = useState();
    const[title,setTitle]=useState(false);
    const onResized = (data) => setMessageData(data);
    const { capabilitiesConfig, env, gatewayAnalytics } = appConfig;
    const invoiceStreamId= props?.history?.location?.state?.multiInvoiceSelectedValue;
    // const invoiceStreamName=props?.history?.location?.state?.invoiceStreamName;
    const multiStreamArray = props?.history?.location?.state?.multiInvoiceStreamData;
    const [invoiceStreamName,setInvoiceStreamName] = useState();
    const creditCard=props.creditCard;
    const prefix = _.get(env, "DEPLOYMENT_URL");

    useEffect(() => {
        // eslint-disable-next-line array-callback-return
        multiStreamArray?.map((itm)=>{
            if(itm.code === invoiceStreamId){                
                window.sessionStorage.setItem("invoiceName", itm.name)
            }
        })
        window.sessionStorage.setItem("invoiceStreamId", invoiceStreamId)
        BillingService.getCreditCardProperties_Ext(accountNumber, authHeader).then(
            (res) => {                
                setCreditCardInfo(res);
            }
        );
    }, []);

    const onMessage = (data) => {
        setMessageData(data);
    };
 

    useEffect(()=>{
        if(messageData!==undefined&&messageData.message)
        {
            if (messageData.message.title === "cancel") {
                // history.push(`/accounts/${accountNumber}/billingAndPayment`);
                return history.push({
                    pathname: `/accounts/${accountNumber}/billingAndPayment`,
                    state: {
                      selectedMultiInvoceStreamName:window.sessionStorage.invoiceName
                  },
                });
            }
            else if (messageData.message.title === "getTokenAndSubmit") {
                BillingService.generatePaymentTokenForAgents(
                    accountNumber,
                    authHeader
                ).then((res) => {
                    setLoadingState(false);
                    ref.current.sendMessage(
                        { title: "setTokenAndSubmit", value: res },
                        `${prefix}/`
                    );
                });
            }
            else if( messageData.message.title === "ready"&&title===false){
                setTitle(true);
            }
            else if(messageData.message.title === "hideSourceDropdown"&&title===true)
            {
                setTitle(false);             
                setCallback('hideSourceDropdown') 
                creditCard(true);   
            }
            else if(messageData.message.title === "showSourceDropdown"&&title===false)
            {
                setTitle(true);   
                setCallback('showSourceDropdown')
                creditCard(false);
                
            }

        }

    },[accountNumber, authHeader, creditCard, history, messageData, prefix, setCallback, title])

    const url = () => {
        const bluePayHost = "https://secure.bluepay.com/interfaces/shpf?";
        const argsArray = [];
        //
        // bp10emu API
        //
        argsArray.push(`MERCHANT=${creditCardInfo.merchant}`);

        // argsArray.push(`DBA=${creditCardInfo.dba}`);
        // argsArray.push(`TRANSACTION_TYPE=${creditCardInfo.transactionType}`);
        argsArray.push(`DBA=${`${creditCardInfo.dba} ${creditCardInfo.multiStreamDropDownArray}`}`);
        argsArray.push(`TRANSACTION_TYPE=${`${creditCardInfo.transactionType}`}`);



        argsArray.push(`MODE=${creditCardInfo.mode}`);
        argsArray.push(`TAMPER_PROOF_SEAL=${creditCardInfo.tpsKey}`);
        argsArray.push(`TPS_DEF=${creditCardInfo.tpsDef}`);
        argsArray.push(`RESPONSEVERSION=${creditCardInfo.responseVersion}`);
        //
        // SHPF API
        //
        argsArray.push(`SHPF_FORM_ID=${creditCardInfo.shpfFormId}`);
        argsArray.push(`SHPF_ACCOUNT_ID=${creditCardInfo.shpfAccountId}`);
        argsArray.push(`SHPF_TPS=${creditCardInfo.shpfKey}`);
        argsArray.push(`SHPF_TPS_DEF=${creditCardInfo.shpfTpsDef}`);
        //
        // CPMI API
        //
        console.log(amountDue);
        const finalAmount = Number(amountDue.amount).toFixed(2)
        if (finalAmount > 0) argsArray.push(`AMOUNT=${finalAmount}`);
        else argsArray.push(`AMOUNT=`);

        argsArray.push(`EMAIL=${email}`);
        argsArray.push(`NAME1=`);
        argsArray.push(`NAME2=`);
        argsArray.push(`CUSTOM_ID=${creditCardInfo.customId1}`);
        argsArray.push(`ORDER_ID=${creditCardInfo.accountNumber}`);
        // argsArray.push(`APPROVED_URL=${creditCardInfo.approvedUrl}`);
        // argsArray.push(`DECLINED_URL=${creditCardInfo.declinedUrl}`);
        // argsArray.push(`MISSING_URL=${creditCardInfo.missingUrl}`);
        argsArray.push(`APPROVED_URL=${prefix}/producer-engage/paymentinfo`);
        argsArray.push(`DECLINED_URL=${prefix}/producer-engage/paymentinfo`);
        argsArray.push(`MISSING_URL=${prefix}/producer-engage/paymentinfo`);

        const appendArgs = argsArray.join("&");
        const encodedURL = encodeURI(bluePayHost + appendArgs);

        return encodedURL;
    };

    if (isLoading) {
        return (
            <>
                <LoaderExt loaded={!isLoading} />
                <IframeResizer
                    className={title?styles.bluepay:styles.bluepayHeight}
                    log
                    inPageLinks
                    forwardRef={ref}
                    src={url()}
                    onResized={onResized}
                    onMessage={onMessage}
                    width="100%"
                    scrolling="no"
                    checkOrigin="false"
                    style={{ border: "0px" }}
            />
            </>
        );
      }

    return (
        <div>
            <IframeResizer
                className={title?styles.bluepay:styles.bluepayHeight}
                log
                inPageLinks
                forwardRef={ref}
                src={url()}
                onResized={onResized}
                onMessage={onMessage}
                width="100%"
                scrolling="no"
                checkOrigin="false"
                style={{ border: "0px" }}
            />
        </div>
    );
}
BluePay.propTypes = {
    history: PropTypes.shape({
        push: PropTypes.func,
        goBack: PropTypes.func,
        location: PropTypes.shape({
            state: PropTypes.shape({}),
        }),
    }).isRequired,
};

export default withRouter(BluePay);
